var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnifyingGlassDark = function SvgMagnifyingGlassDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#131B20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m21 21.5-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.696a7.5 7.5 0 0 0 10.607 10.607"
  })));
};
export { SvgMagnifyingGlassDark as ReactComponent };
export default __webpack_public_path__ + "8eaa5090f856c071e38de41789b10a6e.svg";